module.exports = __webpack_public_path__ + "static/media/adjust_categories_mobile.9d56c899.mp4";